import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';

import App from './App';
import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));
